import {
    ActionService,
    ConfigurationService,
    EntityData,
    field,
    JwtHttpClientService,
    ResourceModule
} from "@fedelta-pos/data-client";
import {inject, Injectable} from "@angular/core";

export class AppDeviceLoginActionData extends EntityData<AppDeviceLoginActionData> {
    @field waiterName: string;
    @field deviceName: string;
}

/**
 * Service to record a login on a device.
 */
@Injectable({providedIn: "root"})
export class AppDeviceLoginService extends ActionService {

    constructor() {
        const http: JwtHttpClientService = inject(JwtHttpClientService);
        const configService: ConfigurationService = inject(ConfigurationService);
        const nameSpace: string = inject<string>(ResourceModule.RESOURCE_NAMESPACE_KEY);
        const actionNames: string[] = inject<string[]>(ResourceModule.ACTION_NAMES_KEY);
        const useAsync: boolean = inject<boolean>(ResourceModule.RESOURCE_USE_ASYNC);

        console.log("--- AppDeviceLoginService");

        super(http, nameSpace, "app-device-login", configService, useAsync, actionNames);
    }
}
